import { render, staticRenderFns } from "./PostPaid.vue?vue&type=template&id=2ec71074&scoped=true&"
import script from "./PostPaid.vue?vue&type=script&lang=js&"
export * from "./PostPaid.vue?vue&type=script&lang=js&"
import style0 from "./PostPaid.vue?vue&type=style&index=0&id=2ec71074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec71074",
  null
  
)

export default component.exports